<div class="">
    <!-- Encabezado -->
    <div class="bg-[var(--tertiary)] py-12">
        <div class="container-padding mx-auto max-w-screen-desktop">
          <h1 class="uppercase text-[var(--beige)] text-[40px]/[40px] font-normal mobile-m:text-left text-center">{{ 'profile.title' | translate }}</h1>
        </div>
    </div>

    <!-- Skeleton -->
    <div *ngIf="isLoading" class="mx-auto max-w-screen-desktop container-padding">
        <!-- Avatar + nombre skeleton -->
        <div class="flex items-center gap-6 py-8">
            <app-skeleton dimensions="w-16 h-16 rounded-full"></app-skeleton>
            <div class="flex flex-col gap-2">
                <app-skeleton dimensions="h-8 w-48"></app-skeleton>
                <app-skeleton dimensions="h-4 w-32"></app-skeleton>
            </div>
        </div>

        <div class="grid grid-cols-1 mobile-m:grid-cols-12 gap-8 pb-12">
            <!-- Nav skeleton -->
            <div class="space-y-4 mobile-m:col-span-4">
                <app-skeleton dimensions="h-14 w-full rounded-xl"></app-skeleton>
                <app-skeleton dimensions="h-14 w-full rounded-xl"></app-skeleton>
            </div>

            <!-- Contenido skeleton -->
            <div class="mobile-m:col-span-8">
                <div class="p-8 rounded-xl border-4 border-[var(--grey)]">
                    <app-skeleton dimensions="h-9 w-56 mb-6"></app-skeleton>
                    <div class="flex items-center justify-between mb-6">
                        <div class="flex flex-col gap-2">
                            <app-skeleton dimensions="h-4 w-28"></app-skeleton>
                            <app-skeleton dimensions="h-4 w-40"></app-skeleton>
                        </div>
                        <app-skeleton dimensions="h-10 w-20 rounded-xl"></app-skeleton>
                    </div>
                    <div class="flex items-center justify-between">
                        <div class="flex flex-col gap-2">
                            <app-skeleton dimensions="h-4 w-20"></app-skeleton>
                            <app-skeleton dimensions="h-4 w-32"></app-skeleton>
                        </div>
                        <app-skeleton dimensions="h-10 w-20 rounded-xl"></app-skeleton>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Contenido principal -->
    <div *ngIf="!isLoading && userInfo" class="mx-auto max-w-screen-desktop container-padding">
        <!-- Sección de bienvenida -->
        <div class="flex items-center gap-6 py-8">
            <div class="avatar">
                <div class="flex justify-center items-center bg-[var(--secondary)] text-[var(--white)] rounded-full w-16 h-16 text-3xl border-4 border-[var(--tertiary)]">
                    <h2>{{ userInfo?.name?.[0] || 'U' }}</h2>
                </div>
            </div>
            <div>
                <h1 class="text-[37px]/[37px] font-normal uppercase text-[var(--tertiary)]">{{ userInfo?.name || 'DrinkHopper' }}</h1>
                <p class="text-[var(--secondary)] mt-1 font-medium">{{ userInfo?.email }}</p>
            </div>
        </div>

        <!-- Contenedor principal -->
        <div class="grid grid-cols-1 mobile-m:grid-cols-12 gap-8 pb-12">
            <!-- Navegación -->
            <div class="space-y-4 mobile-m:col-span-4">
                <button 
                    (click)="activeTab = 'profile'"
                    [class]="activeTab === 'profile' 
                        ? 'bg-[var(--tertiary)] text-[var(--white)]' 
                        : 'hover:bg-[var(--beige)] hover:text-[var(--tertiary)]'"
                    class="w-full text-left p-4 rounded-xl font-normal uppercase transition-all duration-300 border-4 border-[var(--tertiary)]"
                >
                    {{ 'profile.personalInfo' | translate }}
                </button>
                <button 
                    (click)="activeTab = 'security'"
                    [class]="activeTab === 'security' 
                        ? 'bg-[var(--tertiary)] text-[var(--white)]' 
                        : 'hover:bg-[var(--beige)] hover:text-[var(--tertiary)]'"
                    class="w-full text-left p-4 rounded-xl font-normal uppercase transition-all duration-300 border-4 border-[var(--tertiary)]"
                >
                    {{ 'profile.security' | translate }}
                </button>
                <a *ngIf="userInfo?.affiliateId"
                    routerLink="/affiliate"
                    class="block w-full text-left p-4 rounded-xl font-normal uppercase transition-all duration-300 border-4 border-[var(--tertiary)] hover:bg-[var(--beige)] hover:text-[var(--tertiary)] no-underline text-inherit"
                >
                    {{ 'profile.payouts' | translate }}
                </a>
            </div>

            <!-- Contenido -->
            <div class="mobile-m:col-span-8">
                <!-- Información personal -->
                <div *ngIf="activeTab === 'profile'" class="space-y-6">
                    <div class="p-8 rounded-xl border-4 border-[var(--tertiary)]">
                        <div class="flex items-center justify-between mb-6">
                            <h2 class="text-[37px]/[37px] font-normal uppercase text-[var(--tertiary)]">{{ 'profile.personalInfo' | translate }}</h2>
                        </div>

                        <div class="flex items-center justify-between mb-6">
                            <div>
                                <p class="font-semibold text-[var(--tertiary)] uppercase">{{ 'profile.currentName' | translate }}</p>
                                <p class="text-[var(--secondary)] font-medium">{{ userInfo?.name }}</p>
                            </div>
                            <button 
                              (click)="showNameForm = !showNameForm"
                              class="py-2 px-4 rounded-xl border-2 border-[var(--tertiary)] hover:bg-[var(--tertiary)] hover:text-white uppercase font-normal transition-all duration-300"
                            >
                              {{ 'profile.edit' | translate }}
                            </button>
                        </div>
                
                        <form 
                            *ngIf="showNameForm"
                            [formGroup]="nameForm"
                            (submit)="onSubmitName()"
                            class="space-y-4 animate-fade-in"
                          >
                            <app-input
                              [control]="nameForm.controls['name']"
                              [label]="'profile.newFullName' | translate"
                              [placeholder]="'profile.enterNewName' | translate"
                            ></app-input>
                
                            <div class="flex gap-4 justify-end">
                              <button type="button" (click)="showNameForm = false"
                                class="py-2 px-4 rounded-xl border-2 border-[var(--tertiary)] hover:bg-[var(--beige)] uppercase font-normal transition-all duration-300">
                                {{ 'profile.cancel' | translate }}
                              </button>
                              <app-button [submit]="true" [disabled]="isLoadingName"
                                [text]="isLoadingName ? ('profile.saving' | translate) : ('profile.save' | translate)"
                                [styleType]="'primary'"></app-button>
                            </div>
                        </form>
                        
                        <div *ngIf="errorMessageName" class="mt-6 font-bold text-[14px]/[14px] text-center text-red-600">
                            {{ errorMessageName }}
                        </div>
                
                        <div *ngIf="successMessageName" class="mt-6 font-bold text-[14px]/[14px] text-center text-green-600">
                            {{ successMessageName }}
                        </div>


                        <!-- uno para el telefono -->
                        <div class="flex items-center justify-between mb-6">
                            <div>
                                <p class="font-semibold text-[var(--tertiary)] uppercase">{{ 'profile.phone' | translate }}</p>
                                <p class="text-[var(--secondary)] font-medium">{{ userInfo?.phone }}</p>
                            </div>
                            <button (click)="showPhoneForm = !showPhoneForm"
                              class="py-2 px-4 rounded-xl border-2 border-[var(--tertiary)] hover:bg-[var(--tertiary)] hover:text-white uppercase font-normal transition-all duration-300">
                              {{ 'profile.edit' | translate }}
                            </button>
                        </div>

                        <form *ngIf="showPhoneForm" [formGroup]="phoneForm" (submit)="onSubmitPhone()" class="flex flex-col gap-6">
                          <app-input-phone [control]="phoneForm.controls['phone']" inputId="phone" type="phone" autocomplete="phone" [label]="'profile.phone' | translate"></app-input-phone>
                          <div class="flex gap-4 justify-end">
                            <button type="button" (click)="showPhoneForm = false"
                              class="py-2 px-4 rounded-xl border-2 border-[var(--tertiary)] hover:bg-[var(--beige)] uppercase font-normal transition-all duration-300">
                              {{ 'profile.cancel' | translate }}
                            </button>
                            <app-button [submit]="true" [disabled]="isLoadingPhone"
                              [text]="isLoadingPhone ? ('profile.saving' | translate) : ('profile.save' | translate)"
                              [styleType]="'primary'"></app-button>
                          </div>
                        </form>
                    </div>
                </div>

                <!-- Seguridad -->
                <div *ngIf="activeTab === 'security'" class="space-y-6">
                    <div class="p-8 rounded-xl border-4 border-[var(--tertiary)]">
                        <div class="flex items-center justify-between mb-6">
                            <h2 class="text-[37px]/[37px] font-normal uppercase text-[var(--tertiary)]">{{ 'profile.accountSecurity' | translate }}</h2>
                        </div>

                        <div class="flex items-center justify-between mb-6">
                            <div>
                                <p class="font-semibold text-[var(--tertiary)] uppercase">{{ 'profile.password' | translate }}</p>
                                <p class="text-[var(--secondary)] font-medium">******</p>
                            </div>
                            <button (click)="showPasswordForm = !showPasswordForm"
                              class="py-2 px-4 rounded-xl border-2 border-[var(--tertiary)] hover:bg-[var(--tertiary)] hover:text-white uppercase font-normal transition-all duration-300">
                              {{ 'profile.edit' | translate }}
                            </button>
                        </div>

                        <form *ngIf="showPasswordForm"
                        [formGroup]="passwordForm"
                        (submit)="onSubmitPassword()"
                        class="flex flex-col gap-6"
                      >
                        <app-input [control]="passwordForm.controls['oldPassword']" [label]="'profile.currentPassword' | translate" type="password" placeholder="******"></app-input>
                        <app-input [control]="passwordForm.controls['newPassword']" [label]="'profile.newPassword' | translate" type="password" placeholder="******"></app-input>
                        <app-input [control]="passwordForm.controls['confirmPassword']" [label]="'profile.confirmPassword' | translate" type="password" placeholder="******"></app-input>

                        <div class="flex gap-4 justify-end">
                            <button type="button" (click)="showPasswordForm = false"
                              class="py-2 px-4 rounded-xl border-2 border-[var(--tertiary)] hover:bg-[var(--beige)] uppercase font-normal transition-all duration-300">
                              {{ 'profile.cancel' | translate }}
                            </button>
                            <app-button [submit]="true" [disabled]="isLoadingPassword"
                              [text]="isLoadingPassword ? ('profile.saving' | translate) : ('profile.save' | translate)"
                              [styleType]="'primary'"></app-button>
                          </div>
                      </form>

                      <div *ngIf="errorMessagePassword" class="mt-6 font-bold text-[14px]/[14px] text-center text-red-600">
                        {{ errorMessagePassword }}
                      </div>
            
                      <div *ngIf="successMessagePassword" class="mt-6 font-bold text-[14px]/[14px] text-center text-green-600">
                          {{ successMessagePassword }}
                      </div>
                    </div>

                    <!-- Métodos de ingreso -->
                    <div class="p-8 rounded-xl border-4 border-[var(--tertiary)] mt-6" *ngIf="userInfo?.social_accounts">
                      <h2 class="text-[28px]/[36px] font-normal uppercase text-[var(--tertiary)] mb-6">{{ 'profile.loginMethods' | translate }}</h2>

                      <div *ngFor="let account of userInfo?.social_accounts" class="flex items-center justify-between mb-4">
                        <div>
                          <p class="font-semibold text-[var(--tertiary)] uppercase">{{ account.provider }}</p>
                          <p class="text-[var(--secondary)] font-medium text-sm">{{ 'profile.linked' | translate }}</p>
                        </div>
                        <button (click)="onUnlinkProvider(account.provider)" [disabled]="!!isLoadingUnlink"
                          class="py-2 px-4 rounded-xl border-2 border-red-500 text-red-500 hover:bg-red-500 hover:text-white uppercase font-normal transition-all duration-300">
                          {{ isLoadingUnlink === account.provider ? ('profile.unlinking' | translate) : ('profile.unlink' | translate) }}
                        </button>
                      </div>

                      <div *ngIf="errorMessageSocial" class="mt-4 font-bold text-[14px]/[14px] text-center text-red-600">
                        {{ errorMessageSocial }}
                      </div>
                      <div *ngIf="successMessageSocial" class="mt-4 font-bold text-[14px]/[14px] text-center text-green-600">
                        {{ successMessageSocial }}
                      </div>
                    </div>

                    <!-- Sesiones activas -->
                    <div class="p-8 rounded-xl border-4 border-[var(--tertiary)] mt-6">
                      <div class="flex items-center justify-between mb-6">
                        <div>
                          <h2 class="text-[28px]/[36px] font-normal uppercase text-[var(--tertiary)]">{{ 'profile.activeSessions' | translate }}</h2>
                          <p class="text-[var(--secondary)] text-sm mt-1">{{ 'profile.activeSessionsDesc' | translate }}</p>
                        </div>
                        <button (click)="loadSessions()" [disabled]="isLoadingSessions"
                          class="py-2 px-4 rounded-xl border-2 border-[var(--tertiary)] hover:bg-[var(--tertiary)] hover:text-white uppercase font-normal transition-all duration-300 disabled:opacity-50">
                          {{ isLoadingSessions ? ('profile.loading' | translate) : sessionsLoaded ? ('profile.update' | translate) : ('profile.viewSessions' | translate) }}
                        </button>
                      </div>

                      <div *ngIf="isLoadingSessions" class="flex justify-center py-8">
                        <div class="w-8 h-8 border-4 border-[var(--tertiary)] border-t-transparent rounded-full animate-spin"></div>
                      </div>

                      <div *ngIf="sessionsLoaded && !isLoadingSessions">
                        <div *ngIf="sessions.length === 0" class="text-center text-[var(--secondary)] py-8">
                          {{ 'profile.noSessions' | translate }}
                        </div>

                        <div *ngFor="let session of sessions"
                          class="flex items-center justify-between py-4 border-b border-[var(--beige)] last:border-0"
                          [class.bg-[var(--beige)]]="session.isCurrent"
                        >
                          <div class="flex items-start gap-4">
                            <span class="text-3xl mt-0.5">{{ session.parsedDevice?.icon }}</span>
                            <div>
                              <div class="flex items-center gap-2 flex-wrap">
                                <p class="font-semibold text-[var(--tertiary)] text-sm">
                                  {{ session.parsedDevice?.browser }} · {{ session.parsedDevice?.os }}
                                </p>
                                <span *ngIf="session.isCurrent"
                                  class="text-xs bg-[var(--tertiary)] text-white px-2 py-0.5 rounded-full uppercase font-medium">
                                  {{ 'profile.currentSession' | translate }}
                                </span>
                                <span class="text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full uppercase">
                                  {{ session.platform }}
                                </span>
                              </div>
                              <p class="text-[var(--secondary)] text-xs mt-1">
                                {{ session.ipAddress || ('profile.unknownIp' | translate) }}
                              </p>
                              <p class="text-[var(--secondary)] text-xs">
                                {{ 'profile.startedAt' | translate }} {{ session.createdAt | date:'dd/MM/yyyy' }} {{ 'profile.at' | translate }} {{ session.createdAt | date:'HH:mm' }}
                              </p>
                            </div>
                          </div>
                          <button
                            *ngIf="!session.isCurrent"
                            (click)="revokeSession(session.id)"
                            [disabled]="isRevokingSession === session.id"
                            class="ml-4 py-1.5 px-3 rounded-xl border-2 border-red-400 text-red-400 hover:bg-red-400 hover:text-white text-xs uppercase font-normal transition-all duration-300 disabled:opacity-40 disabled:cursor-not-allowed shrink-0"
                          >
                          {{ isRevokingSession === session.id ? '...' : ('profile.close' | translate) }}
                          </button>
                        </div>

                        <div *ngIf="sessions.length > 1" class="mt-6 pt-4 border-t border-[var(--beige)] flex justify-end">
                          <button
                            (click)="revokeAllSessions()"
                            [disabled]="isRevokingAll"
                            class="py-2 px-4 rounded-xl border-2 border-red-500 text-red-500 hover:bg-red-500 hover:text-white text-sm uppercase font-normal transition-all duration-300 disabled:opacity-40"
                          >
                            {{ isRevokingAll ? ('profile.closingAll' | translate) : ('profile.closeAllSessions' | translate) }}
                          </button>
                        </div>
                      </div>

                      <div *ngIf="errorMessageSessions" class="mt-4 text-sm text-center text-red-600 font-medium">
                        {{ errorMessageSessions }}
                      </div>
                      <div *ngIf="successMessageSessions" class="mt-4 text-sm text-center text-green-600 font-medium">
                        {{ successMessageSessions }}
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
